import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom'
import Homepage from './components/homepage/Homepage'
import Room from './components/homepage/Room'
import Admin from './components/admin/Admin'
import NotFound from './components/not-found/NotFound'
import SubscriptionRenewSuccess from './components/subscription/SubscriptionRenewSuccess'
import SubscribeSuccess from './components/subscription/SubscribeSuccess'
import Checkout from './components/subscription/Checkout'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
  apiKey: '3988ef61e9cc964d6d0eeba027ff0863',
  plugins: [new BugsnagPluginReact()]
})

class App extends React.Component {
  render() {
    return (
      <div>
        <Routes>
          <Route path='admin' element={<Admin />} />
          <Route path='checkout' element={<Checkout />} />
          <Route path='renew-success' element={<SubscriptionRenewSuccess />} />
          <Route path='subscribe-success' element={<SubscribeSuccess />} />
          <Route path='room/:room_name' element={<Room />} />
          <Route path='' element={<Homepage />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
    )
  }
}

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
)
